import React from "react";
import { connect } from 'react-redux';
import { NavLink, Link, withRouter } from "react-router-dom";
import { fetchPosts } from '../../../features/posts/store/posts.actions';
import { hasCap } from '../../../helpers/functions';
import { routes } from "../../../routing/routes";
import { UseAuth } from "../../../hooks/UseAuth";
import { resetUser } from '../../../stores/app/app.actions';
import { AppUserSelector } from '../../../stores/app/app.selectors';
import cx from 'classnames/bind'

function Header(props) {
  const auth = UseAuth();
  const [adminPanelOpen, setAdminPanelOpen] = React.useState(false);
  const isAdmin = props.user && hasCap('ADMIN', props.user.capability);
  const isHR = props.user && hasCap('RH', props.user.capability);

  return (
    <header className="header">
      <div className={cx({
        "container md:px-6 mx-auto flex header__wrapper": true,
        "justify-between": props.user,
        "justify-center": !props.user
      })}>
        <Link to="/" className="brand flex">
          <svg
            width="100%" height="100%" viewBox="0 0 18 18" version="1.1"
            className="svg replaced-svg">
            <path
              d="M3.766,15.067l2.936,0l0,2.933l-2.936,0l0,-2.933Zm7.532,0l2.936,0l0,2.933l-2.936,0l0,-2.933Zm-11.298,-3.766l2.936,0l0,2.932l-2.936,0l0,-2.932Zm3.766,0l2.936,0l0,2.932l-2.936,0l0,-2.932Zm3.766,0l2.936,0l0,2.932l-2.936,0l0,-2.932Zm3.766,0l2.936,0l0,2.932l-2.936,0l0,-2.932Zm3.766,0l2.936,0l0,2.932l-2.936,0l0,-2.932Zm-11.298,-3.767l2.936,0l0,2.932l-2.936,0l0,-2.932Zm7.532,0l2.936,0l0,2.932l-2.936,0l0,-2.932Zm-11.298,-3.767l2.936,0l0,2.932l-2.936,0l0,-2.932Zm3.766,0l2.936,0l0,2.932l-2.936,0l0,-2.932Zm3.766,0l2.936,0l0,2.932l-2.936,0l0,-2.932Zm3.766,0l2.936,0l0,2.932l-2.936,0l0,-2.932Zm3.766,0l2.936,0l0,2.932l-2.936,0l0,-2.932Zm-11.298,-3.767l2.936,0l0,2.932l-2.936,0l0,-2.932Zm10.468,0l0,2.932l-2.936,0l0,-2.932l2.936,0Z" />
          </svg>
          <span className="text-gray-900 fonts-black text-2xl">COSAVOSTRA</span>
        </Link>
        {props.user &&
          <p className="text-gray-600 font-light flex flex-col items-center" style={{
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)'
          }}>
            <span>
              <span aria-label="hello" className="inline-block mr-1" role="img">✌️</span>
              {props.user.name}
            </span>
            <span style={{ cursor: 'pointer' }} className="block mt-2 font-black" onClick={() => {
              props.resetUser()
              setTimeout(() => auth.signout(), 100)
            }}>
              Déconnexion
            </span>
          </p>
        }
        <div className="navigation flex items-center">
          {routes.map(
            r =>
              r.routeProps &&
                r.routeProps.main_nav !== undefined &&
                r.private && props.user ?
                (
                  <NavLink
                    key={r.path}
                    className="navigation__link"
                    to={r.routeProps.main_nav_link}
                  >
                    {r.routeProps.main_nav_label}
                  </NavLink>
                ) : null
          )}
          {props.user && (
            <>
              {(isAdmin || isHR) &&
                <div className="relative admin-menu">
                  <div onClick={() => setAdminPanelOpen(!adminPanelOpen)} style={{ cursor: 'pointer' }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd"
                        d="M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12ZM15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
                        fill="#0C0C0E" />
                      <path fillRule="evenodd" clipRule="evenodd"
                        d="M13.8654 2.99312C12.9743 1.66896 11.0257 1.66896 10.1346 2.99312L9.54452 3.86998C9.00062 4.03405 8.47986 4.25112 7.98829 4.51507L6.95021 4.31214C5.38377 4.00592 4.00592 5.38378 4.31214 6.95021L4.51507 7.98829C4.25112 8.47986 4.03405 9.00062 3.86998 9.54452L2.99312 10.1346C1.66896 11.0257 1.66896 12.9743 2.99312 13.8654L3.86998 14.4555C4.03405 14.9994 4.25112 15.5201 4.51507 16.0117L4.31214 17.0498C4.00592 18.6162 5.38378 19.9941 6.95021 19.6879L7.98829 19.4849C8.47986 19.7489 9.00062 19.9659 9.54452 20.13L10.1346 21.0069C11.0257 22.331 12.9743 22.331 13.8654 21.0069L14.4555 20.13C14.9994 19.9659 15.5201 19.7489 16.0117 19.4849L17.0498 19.6879C18.6162 19.9941 19.9941 18.6162 19.6879 17.0498L19.4849 16.0117C19.7489 15.5201 19.9659 14.9994 20.13 14.4555L21.0069 13.8654C22.331 12.9743 22.331 11.0257 21.0069 10.1346L20.13 9.54452C19.9659 9.00062 19.7489 8.47986 19.4849 7.98829L19.6879 6.95021C19.9941 5.38378 18.6162 4.00592 17.0498 4.31214L16.0117 4.51507C15.5201 4.25112 14.9994 4.03405 14.4555 3.86998L13.8654 2.99312ZM11.7939 4.10974C11.8923 3.96342 12.1077 3.96342 12.2061 4.10974L13.2166 5.61128L13.5884 5.70475C14.2079 5.8605 14.7923 6.10548 15.3272 6.42555L15.6562 6.62242L17.4335 6.27499C17.6066 6.24115 17.7588 6.39341 17.725 6.5665L17.3776 8.34376L17.5744 8.67278C17.8945 9.20769 18.1395 9.79207 18.2952 10.4116L18.3887 10.7834L19.8903 11.7939C20.0366 11.8923 20.0366 12.1077 19.8903 12.2061L18.3887 13.2166L18.2952 13.5884C18.1395 14.2079 17.8945 14.7923 17.5744 15.3272L17.3776 15.6562L17.725 17.4335C17.7588 17.6066 17.6066 17.7588 17.4335 17.725L15.6562 17.3776L15.3272 17.5744C14.7923 17.8945 14.2079 18.1395 13.5884 18.2952L13.2166 18.3887L12.2061 19.8903C12.1077 20.0366 11.8923 20.0366 11.7939 19.8903L10.7834 18.3887L10.4116 18.2952C9.79207 18.1395 9.20769 17.8945 8.67278 17.5744L8.34376 17.3776L6.5665 17.725C6.3934 17.7589 6.24115 17.6066 6.27499 17.4335L6.62242 15.6562L6.42555 15.3272C6.10548 14.7923 5.8605 14.2079 5.70475 13.5884L5.61128 13.2166L4.10974 12.2061C3.96342 12.1077 3.96342 11.8923 4.10974 11.7939L5.61128 10.7834L5.70475 10.4116C5.8605 9.79207 6.10548 9.20769 6.42555 8.67278L6.62242 8.34376L6.27499 6.5665C6.24115 6.39341 6.39341 6.24115 6.5665 6.27499L8.34376 6.62242L8.67278 6.42555C9.20769 6.10548 9.79207 5.8605 10.4116 5.70475L10.7834 5.61128L11.7939 4.10974Z"
                        fill="#0C0C0E" />
                    </svg>
                    {adminPanelOpen &&
                      <div className="admin-menu__sub-menu">
                        {isAdmin &&
                          <Link to={'/admin/users'} className="button font-normal">Gestion des utilisateurs</Link>
                        }
                        <Link to={'/admin/rejection-mails'} className="button font-normal">Gestion des mails de refus</Link>
                        {/*<button  onClick={e => {e.stopPropagation();newInternalReferent()}}  className="button font-normal">*/}
                        {/*  Nouvel utilisateur*/}
                        {/*</button>*/}
                      </div>}
                  </div>
                </div>
              }
            </>
          )}

        </div>
      </div>
    </header>
  );
}

export default withRouter(
  connect(
    state => ({
      user: AppUserSelector(state)
    }),
    {
      fetchPosts,
      resetUser
    }
  )(Header)
);
